import React, { useState, useEffect } from 'react';
import { Paper } from 'library';
import { UserPostModel } from '../../NewsfeedModels';
import UserProfile from './components/UserProfile';
import ComingSoon from '../components/ComingSoon';
import Confirmation from '../components/Confirmation';
import { track } from 'shared';
import { useUserContext } from 'UserContext';
interface IProps {
    children: JSX.Element | JSX.Element[];
    user?: UserPostModel;
}

export default function UserProfilePopup({ children, user }: IProps) {
    const [show, setShow] = useState(false);
    const [transition, setTransition] = useState(false);
    const [section, setSection] = useState(0);
    const context = useUserContext();

    useEffect(() => {
        setTransition(show);
    }, [show]);

    function handleSection() {
        switch (section) {
            case 0:
                return <UserProfile user={user as UserPostModel} setSection={(x: number) => setSection(x)} />;
            case 1:
                return <ComingSoon setSection={(x: number) => setSection(x)} />;
            case 2:
                return <Confirmation />;
            default:
                return <></>;
        }
    }

    function handleCloseShow() {
        setTransition(false);

        setTimeout(() => {
            setSection(0);
            setShow(false);
        }, 250);
    }

    function handleOpenShow() {
        track('User Profile Popup: Popup Opened');
        setShow(true);
    }

    if (user && user.id !== context.user?.id && user.role !== 'TANDEM') {
        return (
            <div onMouseEnter={handleOpenShow} onMouseLeave={handleCloseShow} style={{ position: 'relative' }}>
                {children}
                <div
                    style={{
                        display: show ? 'block' : 'none',
                        position: 'absolute',
                        width: 300,
                        paddingTop: 5,
                        zIndex: 100,
                        inset: '50px auto auto 0px',
                        opacity: transition ? 1 : 0,
                        transition: 'all .25s ease',
                        WebkitTransition: 'all .25s ease',
                        MozTransition: 'all .25s ease',
                    }}
                >
                    <Paper elevation={4} padding={15}>
                        {handleSection()}
                    </Paper>
                </div>
            </div>
        );
    } else {
        return <>{children}</>;
    }
}
